 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"2fa":"2fa","client-register":"client-register","close-job":"close-job","company-whitelabel-router":"company-whitelabel-router","create-quote~messaging":"create-quote~messaging","create-quote":"create-quote","favourites":"favourites","forgot-password":"forgot-password","guests-find-a-lawyer~messaging~view-job":"guests-find-a-lawyer~messaging~view-job","messaging~view-job":"messaging~view-job","messaging":"messaging","guests-find-a-lawyer":"guests-find-a-lawyer","view-job":"view-job","integrations":"integrations","jobs":"jobs","landing~landing-view-panel~referral~referral-view-provider":"landing~landing-view-panel~referral~referral-view-provider","landing":"landing","landing-view-panel":"landing-view-panel","referral":"referral","referral-view-provider":"referral-view-provider","login":"login","my-firm":"my-firm","profile":"profile","redeem-client-invite":"redeem-client-invite","redeem-invite":"redeem-invite","reset-password":"reset-password","revenue":"revenue","sage-callback":"sage-callback","sage-integration":"sage-integration","select-user-role":"select-user-role","settings":"settings","setup-account":"setup-account","setup-client-account":"setup-client-account","status-update":"status-update","users":"users","webhooks-integration":"webhooks-integration","whitelabel-configuration":"whitelabel-configuration"}[chunkId]||chunkId) + "." + {"2fa":"2251ca3a","client-register":"6726fe8f","close-job":"bd7ca122","company-whitelabel-router":"71190340","create-quote~messaging":"8627f25d","create-quote":"662e303c","favourites":"3000f92c","forgot-password":"ddfdbcd6","guests-find-a-lawyer~messaging~view-job":"e609f307","messaging~view-job":"26f19d20","messaging":"3916fe03","guests-find-a-lawyer":"f97b8903","view-job":"6f11c2a1","integrations":"a1682be7","jobs":"f440ccf5","landing~landing-view-panel~referral~referral-view-provider":"0468cf88","landing":"8c3a69e1","landing-view-panel":"25a9bf5a","referral":"87d7c9e0","referral-view-provider":"777cc24b","login":"ce2e9ded","my-firm":"2a041705","profile":"d49735a7","redeem-client-invite":"7b1cec78","redeem-invite":"206eefc0","reset-password":"8b472ef7","revenue":"68cd7b30","sage-callback":"c4c903e5","sage-integration":"cc025162","select-user-role":"0564229f","settings":"569a1583","setup-account":"299a57c4","setup-client-account":"c57e0fd6","status-update":"92b238c0","users":"e479cd87","webhooks-integration":"be04ad90","whitelabel-configuration":"ac0ff803"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2fa":1,"client-register":1,"company-whitelabel-router":1,"create-quote~messaging":1,"favourites":1,"forgot-password":1,"messaging~view-job":1,"messaging":1,"guests-find-a-lawyer":1,"view-job":1,"integrations":1,"jobs":1,"landing~landing-view-panel~referral~referral-view-provider":1,"landing":1,"landing-view-panel":1,"referral":1,"referral-view-provider":1,"login":1,"my-firm":1,"profile":1,"redeem-client-invite":1,"redeem-invite":1,"reset-password":1,"revenue":1,"sage-callback":1,"sage-integration":1,"select-user-role":1,"settings":1,"setup-account":1,"setup-client-account":1,"status-update":1,"users":1,"webhooks-integration":1,"whitelabel-configuration":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"2fa":"2fa","client-register":"client-register","close-job":"close-job","company-whitelabel-router":"company-whitelabel-router","create-quote~messaging":"create-quote~messaging","create-quote":"create-quote","favourites":"favourites","forgot-password":"forgot-password","guests-find-a-lawyer~messaging~view-job":"guests-find-a-lawyer~messaging~view-job","messaging~view-job":"messaging~view-job","messaging":"messaging","guests-find-a-lawyer":"guests-find-a-lawyer","view-job":"view-job","integrations":"integrations","jobs":"jobs","landing~landing-view-panel~referral~referral-view-provider":"landing~landing-view-panel~referral~referral-view-provider","landing":"landing","landing-view-panel":"landing-view-panel","referral":"referral","referral-view-provider":"referral-view-provider","login":"login","my-firm":"my-firm","profile":"profile","redeem-client-invite":"redeem-client-invite","redeem-invite":"redeem-invite","reset-password":"reset-password","revenue":"revenue","sage-callback":"sage-callback","sage-integration":"sage-integration","select-user-role":"select-user-role","settings":"settings","setup-account":"setup-account","setup-client-account":"setup-client-account","status-update":"status-update","users":"users","webhooks-integration":"webhooks-integration","whitelabel-configuration":"whitelabel-configuration"}[chunkId]||chunkId) + "." + {"2fa":"1539acbb","client-register":"6f862e65","close-job":"31d6cfe0","company-whitelabel-router":"5b7a81ac","create-quote~messaging":"c338f0cb","create-quote":"31d6cfe0","favourites":"9aead9ea","forgot-password":"2fd3d65d","guests-find-a-lawyer~messaging~view-job":"31d6cfe0","messaging~view-job":"9b452eca","messaging":"50d0f997","guests-find-a-lawyer":"d5faaf33","view-job":"be4bca08","integrations":"7caaa066","jobs":"d84d380d","landing~landing-view-panel~referral~referral-view-provider":"6af2c8cd","landing":"bd471b28","landing-view-panel":"66bb2b17","referral":"38d79266","referral-view-provider":"66bb2b17","login":"53bf2947","my-firm":"0ee54179","profile":"3e4d7e6d","redeem-client-invite":"02ec4705","redeem-invite":"02ec4705","reset-password":"5d2be2b8","revenue":"a6551c2a","sage-callback":"4daa823d","sage-integration":"445b1f97","select-user-role":"876c3990","settings":"17b429d7","setup-account":"a6f83073","setup-client-account":"02ec4705","status-update":"664f547e","users":"348c74d8","webhooks-integration":"0e261bc0","whitelabel-configuration":"850a9e74"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
